import { getPlatformInfraAPI } from '../../../bootstrap/init';
import { ActionFactoryWithPlatformContext } from '../types';
import { PresetsPanelProps } from '@wix/editor-platform-feature-store';

export const presetsActionFactory: ActionFactoryWithPlatformContext = ({
  editorPlatformPackagesBridge,
  editorPointer,
}) => ({
  actionName: 'presets',
  // TODO: [https://wix.atlassian.net/browse/EP-6363] add translation key?
  displayName: 'More Designs',
  tags: [],
  execute: async () => {
    const infra = await getPlatformInfraAPI();

    const hostContext = infra.getSDKHostContext({
      contextBuilder: (builder) => {
        builder.byEditorPointer(editorPointer, (editorElement) => {
          builder.withEditorElement(editorPointer, editorElement);
        });
      },
    });

    const host = hostContext.getHost();

    const panelProps: PresetsPanelProps = { host };

    editorPlatformPackagesBridge?.PresetsPanelUIServiceAPI?.openPresetsPanel(
      panelProps,
    );
  },
});
